import {
  isUserWithRoles, useCombinedUser, useIsMsalAuth, useIsUserAuth, UserRoles,
} from '@equifinance/shared';

export function useCanAccessBrokerDetails(): boolean {
  const isInternalUser = useIsMsalAuth();
  const isExternalUser = useIsUserAuth();
  const { user } = useCombinedUser();

  const isBrokerAdmin = isExternalUser && isUserWithRoles([UserRoles.BROKER_ADMIN], user);
  const isSalesSupport = isInternalUser && isUserWithRoles([UserRoles.SALES_SUPPORT], user);
  const isCompliance = isInternalUser && isUserWithRoles([UserRoles.COMPLIANCE], user);

  return isBrokerAdmin || isSalesSupport || isCompliance;
}
